package com.example.monetix.utils

import com.example.monetix.db.TransactionEntity

// 🚀 NUOVO: Le 3 modalità di esportazione richieste
enum class ExportMode {
    DETAILED, COMPACT_CATEGORY, BALANCE_ONLY
}

interface FileExporter {
    fun exportAndSharePdf(
        transactions: List<TransactionEntity>,
        title: String,
        totalCents: Long,
        categoryNames: Map<String, String>,
        availableBalanceCents: Long, // 🚀 NUOVO: Il saldo da stampare in cima
        exportMode: ExportMode       // 🚀 NUOVO: La modalità scelta dall'utente
    )
}